/* eslint-disable */ import { applicationConfigComponent, canvasConfigComponent, canvasCustomEnvironmentComponent, customSidebarFooterComponent, fitRootPerspectiveCameraComponent, memoEval, toolbarComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const rootEntityComponents = [
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'base', true).withAlias('RootEntity').withGradualFilter({
        active: false
    }).attach(memoEval(()=>[], ()=>({
            priority: 1,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1,
            minDistance: 300,
            maxDistance: 1000
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'default', true).withAlias('RootEntity').withGradualFilter({
        active: true
    }).attach(memoEval(()=>[], ()=>({
            priority: 1,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1,
            minDistance: 300,
            maxDistance: 1000,
            fitToBox: true
        }))),
    attachComponent.withComponent(fitRootPerspectiveCameraComponent, 'focusOnLiner', true).withAlias('RootEntity').withGradualFilter({
        viewStates: [
            'FocusOnLiner'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 3,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 0.2,
            minDistance: 300,
            maxDistance: 1000,
            azimuthAngle: 0
        }))),
    attachComponent.withComponent(applicationConfigComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            chatEnabled: false,
            layout: 'universal',
            shareCloneToEdit: true,
            shareStrategy: 'current-frontend'
        }))),
    attachComponent.withComponent(canvasConfigComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            highlightingDisabled: true
        }))),
    attachComponent.withComponent(canvasCustomEnvironmentComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            name: 'AppEnvironment'
        }))),
    attachComponent.withComponent(toolbarComponent, 'default', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            desktop: [
                {
                    kind: 'toolbarButtonGroup',
                    children: [
                        {
                            kind: 'shareToolbarButton'
                        },
                        {
                            kind: 'undoToolbarButton'
                        },
                        {
                            kind: 'redoToolbarButton'
                        }
                    ]
                }
            ]
        }))),
    attachComponent.withComponent(customSidebarFooterComponent, 'main', true).withAlias('RootEntity').attach(memoEval(()=>[], ()=>({
            children: [
                {
                    kind: 'customLayoutElement',
                    props: {
                        name: 'CustomSidebarFooter'
                    }
                }
            ]
        })))
];

//# sourceMappingURL=root-entity.js.map